import { fetchNot } from "shared/redux-store/defaultActions";
import { fetchOrderGroupsOverview, fetchOrderGroupsOverviewAll } from "../order-groups-overview/orderGroupsOverviewActions";
import { fetchOrderUnitsOverview } from "../order-units-overview/orderUnitsOverviewActions";
import { fetchOrderUnitDetails } from "../order-unit-details/orderUnitDetailsActions";
import { fetchOrderUnitNew } from "../order-unit-details/orderUnitWizardActions";
import { fetchOrderUnitEditor } from "../order-unit-editor/orderUnitEditorActions";
import { fetchWelcomeStatistics } from "../../welcome/welcome/welcomeActions";
import { fetchOrderCreation } from "../order-creation/orderCreationActions";
import {
  fetchDigitalizedOrdersOverview,
  fetchDigitalizedOrdersOverviewAll,
  fetchDigitalizedOrdersDetail,
} from "../digitalized-orders/digitalizedOrdersActions";

export default [
  [/\/startups\/order_groups\/all/, fetchOrderGroupsOverviewAll],
  [/\/startups\/order_groups/, fetchOrderGroupsOverview],
  [/\/startups\/order_units\/([^/]+)\/edit/, fetchOrderUnitEditor],
  [/\/startups\/order_units\/new/, fetchOrderUnitNew],
  [/\/startups\/order_units\/([^/]+)/, fetchOrderUnitDetails],
  [/\/startups\/order_units/, fetchOrderUnitsOverview],
  [/\/startups\/orders\/new/, fetchOrderCreation],
  [/\/startups\/welcome/, fetchWelcomeStatistics],
  [/\/faq\/(.+)/, fetchNot],
  [/\/startups\/digitalized_orders\/all/, fetchDigitalizedOrdersOverviewAll],
  [/\/startups\/digitalized_orders/, fetchDigitalizedOrdersOverview],
  [/\/startups\/digitalized_orders\/([^/]+)/, fetchDigitalizedOrdersDetail],
];
